import { I18NText, Position, State, StateObj } from 'src/types'
import { positionChecker } from 'src/logic'
import { checkAtomsWeb2 } from 'src/features/atoms/glove/logic'

export const useSelectPartsObject = (figurePanelNum: number, position: Position, state: State, t: I18NText): StateObj[] => {
  const existFingerCover = state.fingerGuardType.value !== 'none'
  const frontFigurePanel = 0
  const partsObjects = figurePanelNum === frontFigurePanel ? selectFrontPartsObject(position, t) : selectBackPartsObject(position, t)
  const filteredFingerCoverPartsObjects = existFingerCover ? partsObjects : partsObjects.filter((x) => x.value !== 'indexCover')
  const filteredJointCheckerWebPartsObjects = checkAtomsWeb2(state.webParts?.value, position)
    ? [...filteredFingerCoverPartsObjects, t.WEB2_PARTS_OBJECT].sort((a, b) => a.order - b.order)
    : filteredFingerCoverPartsObjects
  return filteredJointCheckerWebPartsObjects
}

const selectFrontPartsObject = (specifiedPosition: Position, t: I18NText) => {
  if (specifiedPosition === 'catcher') {
    return t.CATCH_FACE_FOR_CATCHER_OBJECTS
  } else {
    return t.CATCH_FACE_OBJECTS
  }
}

// private
const selectBackPartsObject = (specifiedPosition: Position, t: I18NText) => {
  switch (specifiedPosition) {
    case 'pitcher':
      return t.US_MODEL_BACK_OBJECTS
    case 'infielder':
      return t.US_MODEL_BACK_OBJECTS
    case 'outfielder':
      return t.US_MODEL_BACK_OBJECTS
  }
}

export const getPartsItems = (_: Position, state: State) => {
  const {
    all,
    catchFace,
    lace,
    web,
    web2,
    edge,
    stitch,
    hamidashi,
    thumbHook,
    littleHook,
    indexCover,
    linings,
    mouton,
    atomsLabel,
    listBelt,
    littleOut, // 小指左
    thumbWebAndIndexWeb // UBackで使用
  } = state
  const commonParts = {
    all,
    catchFace,
    lace,
    web,
    web2,
    edge,
    stitch,
    hamidashi,
    thumbHook,
    littleHook,
    indexCover,
    linings,
    mouton,
    atomsLabel
  }
  // 投手・内野手・外野手
  return {
    ...commonParts,
    listBelt, // 必要＿王冠・ベルト・ファーストバック
    thumbRoot: state?.thumbRoot, // USモデルのみ
    thumbOut: state?.thumbOut, // 必要＿王冠・ベルト・ファーストバック
    thumbWeb: state?.thumbWeb, // 必要＿王冠・ベルト・
    thumbIndexMiddle: state?.thumbIndexMiddle, // 必要＿ファーストバック
    indexWeb: state?.indexWeb, // 必要＿王冠・ベルト
    indexLeftMiddleRight: state?.indexLeftMiddleRight, // 必要＿王冠
    middleLeftRingRight: state?.middleLeftRingRight, // 必要＿王冠・ファーストバック
    ringLeftLittleRight: state?.ringLeftLittleRight, // 必要＿王冠・ファーストバック
    indexMiddle: state?.indexMiddle, // 必要＿ベルト
    middleIndex: state?.middleIndex, // 必要＿ベルト
    middleRing: state?.middleRing, // 必要＿ベルト
    ringMiddle: state?.ringMiddle, // 必要＿ベルト
    ringLittle: state?.ringLittle, // 必要＿ベルト
    littleRing: state?.littleRing, // 必要＿ベルト
    littleOut, // 必要＿王冠・ベルト・ファーストバック
    thumbWebAndIndexWeb // UBackで必要
  }
}

export const hamidashiObjectSwitcher = (position: Position, t: I18NText): StateObj[] => {
  const { isCatcher } = positionChecker(position)
  return isCatcher ? t.HAMIDASHI_COLOR_FOR_CATCHER_OBJECTS : t.HAMIDASHI_COLOR_OBJECTS
}

export const colorCautionGenerator = (partsKey: string, t: I18NText): string => {
  switch (partsKey) {
    case 'lace':
      return t.CAUTION_LACE
  }
}

// deprecated
export const laceObjectsSwitcher = (position: Position, t: I18NText): StateObj[] => {
  const isMitt = ['catcher', 'first'].includes(position)
  return isMitt ? t.LACE_COLOR_OBJECTS.filter((o) => o.value !== 'tang') : t.LACE_COLOR_OBJECTS
}
